import type React from 'react';
import styles from './VulnerabilityManagement.module.css';

interface VulnStats {
  total: number;
  critical: number;
  high: number;
  medium: number;
  low: number;
}

interface VulnerabilityStatsGridProps {
  stats: VulnStats;
}

interface StatCardEntry {
  gradient: string;
  value: number;
  label: string;
}

const STAT_CARDS: StatCardEntry[] = [
  {
    gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    value: 0,
    label: 'Total Vulnerabilities',
  },
  {
    gradient: 'linear-gradient(135deg, #DC2626 0%, #EF4444 100%)',
    value: 0,
    label: 'Critical',
  },
  {
    gradient: 'linear-gradient(135deg, #EF4444 0%, #F59E0B 100%)',
    value: 0,
    label: 'High',
  },
  {
    gradient: 'linear-gradient(135deg, #F59E0B 0%, #FBBF24 100%)',
    value: 0,
    label: 'Medium',
  },
  {
    gradient: 'linear-gradient(135deg, #10B981 0%, #34D399 100%)',
    value: 0,
    label: 'Low',
  },
];

export const VulnerabilityStatsGrid: React.FC<VulnerabilityStatsGridProps> = ({ stats }) => {
  const statValues = [stats.total, stats.critical, stats.high, stats.medium, stats.low];

  return (
    <div className={styles.statsGrid}>
      {STAT_CARDS.map((card, index) => (
        <div
          key={card.label}
          className={styles.statCard}
          style={
            {
              '--stat-card-color': card.gradient,
            } as React.CSSProperties
          }
        >
          <div
            className={styles.statValue}
            style={
              {
                '--stat-value-color': card.gradient,
              } as React.CSSProperties
            }
          >
            {statValues[index]}
          </div>
          <div className={styles.statLabel}>{card.label}</div>
        </div>
      ))}
    </div>
  );
};
